export const or = <T>(...conditions: Array<(v: T) => boolean>) => (value: T): boolean =>
  conditions.reduce((result: boolean, condition) => result || condition(value), false);

export const and = <T>(...conditions: Array<(v: T) => boolean>) => (value: T): boolean =>
  conditions.reduce((result: boolean, condition) => result && condition(value), true);

export const not = <T>(condition: (v: T) => boolean) => (value: T): boolean =>
  !condition(value);
